import SetFiscalRegimeError from './SetFiscalRegimeError';
class RegimeFileIsNotSended extends SetFiscalRegimeError {
    constructor(regimeType, options) {
        super(`Fiscal Regime File is not sended, is necesary to ${regimeType}`, options);
    }
}
export default RegimeFileIsNotSended;
